module.exports = __webpack_public_path__ + "static/media/0.beginning.e22a6401.mp4";